/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner-wrapper[_ngcontent-%COMP%]{position:fixed;inset:0;z-index:100000;background:rgba(255,255,255,.9);display:flex;align-items:center;justify-content:center}.spinner-wrapper[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%]{z-index:100001}.text-desc[_ngcontent-%COMP%]{color:#999;margin-bottom:1.5rem;font-weight:300;font-size:.8rem;padding-bottom:1rem}"];
export { styles as styles };
